import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";

export const ProtectedRoute = ({ children, adminOnly = true }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="auth-loading">
        <div className="w-10 h-10 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (adminOnly && !user.is_admin) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4" data-testid="not-admin">
        <div className="max-w-md text-center bg-white border border-slate-200 rounded-2xl p-8">
          <ShieldAlert className="w-10 h-10 text-red-500 mx-auto mb-3" />
          <div className="font-display text-2xl font-semibold text-slate-900">Access denied</div>
          <p className="text-sm text-slate-600 mt-2">
            Your account <span className="font-semibold">{user.email}</span> is not on the Loan81 admin whitelist.
          </p>
          <Button asChild className="mt-6 bg-slate-900 hover:bg-slate-800 text-white">
            <a href="/">Return to site</a>
          </Button>
        </div>
      </div>
    );
  }

  return children;
};
